import {
    ADMIN_GET_TRANSACTION_SUB_TYPE_SUCCESS,
    ADMIN_GET_TRANSACTION_SUB_TYPE_FAILED,
    LOADING_ADMIN_GET_TRANSACTION_SUB_TYPE,
    NETWORK_ERROR_ADMIN_GET_TRANSACTION_SUB_TYPE
} from "../types/index";
import { adminServices } from "../../config/axios";

const adminGetTransactionSubType =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_ADMIN_GET_TRANSACTION_SUB_TYPE });
        await adminServices
            .post("gettransactionSubType", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch({ type: ADMIN_GET_TRANSACTION_SUB_TYPE_SUCCESS, payload: res.data });
                        break;
                    default:
                        dispatch({ type: ADMIN_GET_TRANSACTION_SUB_TYPE_FAILED, payload: res.data });
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_ADMIN_GET_TRANSACTION_SUB_TYPE,
                    payload: err
                });
            });
    };

export { adminGetTransactionSubType };
